<template>
    <div>
      <div class="card">
        <div class="card-header row">
          <div class="col-8">
            <h5 class="card-title">Restaurant Drink Menu</h5>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <router-link :to="{ name: 'Restaurant-Drink-Add'}">
              <p-button type="info outline"  @click="handleInfo" outline round>
                <i slot="label" class="nc-icon nc-simple-add"></i>
                Add
              </p-button>
            </router-link>
          </div>
        </div>
        <div class="card-body row">
          <div class="col-sm-12">
            <el-table :data="tableData" header-row-class-name="text-info">
              <el-table-column type="index">
              </el-table-column>
              <!-- <el-table-column min-width="50">
                  <template slot-scope="props">
                    <div class="img-container">
                      <img :src="props.row.PictureURL" alt="Agenda">
                    </div>
                  </template>
                </el-table-column> -->
              <el-table-column prop="DrinkType" min-width="60"
                               label="Type">
              </el-table-column>
              <el-table-column 
                                min-width="60"
                                prop="DrinkName"
                               label="Name">
              </el-table-column>
              <el-table-column prop="DrinkIngredients"
                               label="Ingredients">
              </el-table-column>
              <el-table-column prop="DrinkPrice"
                               min-width="50"
                               align="right"
                               label="Price">
              </el-table-column>
              <el-table-column
                class-name="action-buttons td-actions" min-width="40"
                align="center"
                label="Actions">
                <template slot-scope="props">
                  <p-button type="success" size="sm" icon @click="handleEdit(props.row.ItemID)">
                    <i class="fa fa-edit"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import { collection, getDocs, orderBy, query } from "firebase/firestore";
  import db from "@/components/Firebase/firebaseInit";

  import { Table, TableColumn } from "element-ui";
  Vue.use(Table);
  Vue.use(TableColumn);
  
  export default {
    data() {
      return {
        tableData: [], // Stores the fetched data for the table
      };
    },
    created() {
      this.fetchRegistrations();
    },
methods: {
  handleEdit(id) {
    this.$router.push({ name: "Restaurant-Drink-Edit", params: { id } });
  },
  async fetchRegistrations() {
    try {
      let id = 1;
      const drinkMenuQuery = query(collection(db, "DrinksMenuRestaurant"), orderBy("DrinkType")); // Corrected orderBy usage
      const querySnapshot = await getDocs(drinkMenuQuery);

      this.tableData = querySnapshot.docs.map((doc) => ({
        id: id++, // Generate unique IDs for the rows
        ItemID: doc.id, // Store the document ID for editing
        PictureURL: doc.data().PictureURL,
        DrinkType: doc.data().DrinkType, // Keep array intact for button rendering
        DrinkName: doc.data().DrinkName, // Display the AI task
        DrinkIngredients: doc.data().DrinkIngredients, // Display solution type
        DrinkPrice: Math.round(doc.data().DrinkPrice) + ' ETB', // Round to whole number and append ETB

      }));
    } catch (error) {
      console.error("Error fetching registrations:", error);
    }
  },
}

  };
  </script>
  
  
  <style lang="scss">
    .el-table .td-actions{
      button.btn {
        margin-right: 5px;
      }
    }
  </style>
  